var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PrimaryButton',{attrs:{"onClick":_vm.downloadExcel}},[_vm._v(_vm._s(_vm.text || _vm.$t('components.exportToExcel')))])
}
var staticRenderFns = []

export { render, staticRenderFns }